import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationDE from './locales/de.json';
import translationZH from './locales/zh.json';

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
  zh: { translation: translationZH },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
